import Bout from "../../bout/Bout.js";
import Game from "../../Game.js";
import ItemProviders from "../../items/ItemProviders.js";
import Helper from "../../utils/helper/Helper.js";
import Screen from "../Screen.js";
import Skills from "../skills/Skills.js";

export default class ItemInfo {
	constructor(itemSlot, callback) {
		this.mc = null;
		this.itemSlot = itemSlot;
		this.callback = callback;
		this.player = Bout.that.player;
		this.mc = jQuery("#template-iteminfo").clone();
		this.mc.attr("id", "iteinf" + ItemInfo.ENUM++);

	}

	init() {
		this.build();
	}

	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}


	getClip() {
		return this.mc;

	}

	build() {
		jQuery(".js-image", this.mc).css("background-image", "url('" + "./assets/ui/empty_slot.png" + "')");

		let mc = this.itemSlot.mc.clone();
		mc.attr("id", "itemin" + ItemInfo.ENUM++);
		mc.css({ top: 0, left: 0 });
		jQuery(".js-empty", mc).hide();
		jQuery(".js-over", mc).hide();
		jQuery(".js-image", this.mc).append(mc);

		let item = this.itemSlot.getItem();
		this.item = item;
		if (this.item.isStackable() && (this.item.getStackQuantity() > 1)) {
			jQuery(".js-name", this.mc).text(item.name + " (" + this.item.getStackQuantity() + ")");
		} else {
			jQuery(".js-name", this.mc).text(item.name);
		}
		jQuery(".js-rarity", this.mc).text(item.getDescRarity());
		jQuery(".js-rarity", this.mc).addClass("text-rarity-" + item.rarity);

		jQuery(".js-desc", this.mc).html(item.description);
		if (jQuery.trim(item.description) === "") {
			jQuery(".js-desc", this.mc).hide();
		}

		let template = this.getShowAs(item.type);
		if (template) {
			if (template === ItemProviders.SHOW_ITEM_WEAPON) {
				this.showWeapon();
			}
			if (template === ItemProviders.SHOW_ITEM_ARMOUR) {
				this.showArmour();
			}
			if (template === ItemProviders.SHOW_ITEM_JEWEL) {
				this.showJewel();
			}
			if (template === ItemProviders.SHOW_ITEM_MONEY) {
				this.showMoney();
			}
			if (template === ItemProviders.SHOW_ITEM_FOOD) {
				this.showFood();
			}
			if (template === ItemProviders.SHOW_ITEM_POTION) {
				this.showPotion();
			}
			if (template === ItemProviders.SHOW_ITEM_BOOK) {
				this.showBook();
			}
			if (template === ItemProviders.SHOW_ITEM_RESOURCE) {
				this.showResource();
			}
			if (template === ItemProviders.SHOW_ITEM_KEY) {
				this.showKey();
			}
			if (template === ItemProviders.SHOW_ITEM_TOOL) {
				this.showTool();
			}
		}
		this.buildCtas();


	}


	getShowAs(type) {
		let a = ItemProviders.SHOWN;
		for (let x = 0; x < a.length; x++) {
			if (a[x].types.indexOf(type) >= 0) {
				return a[x].showAs
			}
		}
		return null;
	}

	showWeapon() {
		this.buildLevel();
		this.buildWeaponSkill();
		this.buildMaterial();
		this.buildWeight();
		this.buildGold();
		this.buildSeparator();
		this.buildDamageMinMax();
		this.buildSpeed();
		this.buildBonusSkill();
	}
	showArmour() {
		//		props: ["id", "name", "description", "level", "type", "rarity", "material", "armour_class", "defense", "speed", "bonus_skill", "player_skill", "gold", "weight", "startItem", "worn"],
		this.buildLevel();
		this.buildClass();
		this.buildMaterial();
		this.buildWeight();
		this.buildGold();
		this.buildSeparator();
		this.buildDefense();
		this.buildSpeed();
		this.buildBonusSkill();
	}
	showJewel() {
		this.buildLevel();
		this.buildSeparator();
		this.buildMaterial();
		this.buildWeight();
		this.buildGold();
		this.buildSeparator();
		this.buildBonus();
		this.buildBonusSkill();
	}
	showMoney() {
		// nothing to add
	}
	showFood() {
		this.buildWeight();
		this.buildSeparator();
		this.buildFood();
		this.buildWater();
		this.buildHeal();

	}
	showPotion() {
		this.buildWeight();
		this.buildSeparator();
		this.buildFood();
		this.buildWater();
		this.buildHeal();
	}
	showBook() {
		this.buildLevel();
		this.buildSeparator();
		this.buildWeight();
		this.buildGold();
		this.buildSeparator();
		this.buildBonus();
		this.buildSpeed();
		this.buildBonusSkill();
	}
	showResource() {
		// nothing to add
	}
	showKey() {
		// nothing to add
	}
	showTool() {
		// nothing to add
	}

	newInfoRow() {
		let row = jQuery("#template-info-row").clone();
		row.attr("id", "infrow" + ItemInfo.ENUM++);
		return row;
	}
	newMoreInfoRow() {
		let row = jQuery("#template-more-info-row").clone();
		row.attr("id", "moinro" + ItemInfo.ENUM++);
		return row;
	}

	buildLevel() {
		let row = this.newInfoRow();
		jQuery(".js-sx", row).text("Level");
		let lvl = this.item.level;
		jQuery(".js-dx", row).text("" + lvl);
		this.mc.append(row);
		if (lvl > this.player.currentLevel) {
			//jQuery(".js-sx", row).addClass("text-red");
			jQuery(".js-dx", row).addClass("text-red");
			let mor = this.newMoreInfoRow();
			mor.addClass("text-red");
			mor.text("Your level is too low.");
			this.mc.append(mor);
		}
	}

	buildMaterial() {
		let row = this.newInfoRow();
		jQuery(".js-sx", row).text("Material");
		jQuery(".js-dx", row).text(this.item.getDescMaterial());
		this.mc.append(row);
	}

	buildWeight() {
		let row = this.newInfoRow();
		jQuery(".js-sx", row).text("Weight");
		jQuery(".js-dx", row).text(Helper.toWeight(this.item.getWeight()) + " kg");
		this.mc.append(row);
	}

	buildGold() {
		let row = this.newInfoRow();
		jQuery(".js-sx", row).text("Value");
		jQuery(".js-dx", row).text(Helper.toCoin(this.item.gold) + " gold");
		this.mc.append(row);
	}

	buildWeaponSkill() {
		let row = this.newInfoRow();
		jQuery(".js-sx", row).text(Skills.getSkillName(this.item.weapon_skill));
		jQuery(".js-dx", row).text("");
		this.mc.append(row);
		let skl = this.player.getSkillValue(this.item.weapon_skill);
		if (skl < this.item.skill_needed) {
			//jQuery(".js-sx", row).addClass("text-red");
			jQuery(".js-dx", row).addClass("text-red");
			let mor = this.newMoreInfoRow();
			mor.addClass("text-red");
			mor.text("Requires skill at " + Helper.toSkill(this.item.skill_needed));
			this.mc.append(mor);
		} else {
			let mor = this.newMoreInfoRow();
			mor.html("&nbsp;");
			this.mc.append(mor);
		}

	}

	buildClass() {
		if (this.item.armour_class !== ItemProviders.ARMOUR_CLASS_NONE) {
			let row = this.newInfoRow();
			jQuery(".js-sx", row).text(this.item.getClassArmourName());
			jQuery(".js-dx", row).text("");
			this.mc.append(row);
			let skl = this.player.getSkillValue("ArmourProficiency");
			if (skl < this.item.getMinimumSkillNeededForArmour()) {
				//jQuery(".js-sx", row).addClass("text-red");
				jQuery(".js-dx", row).addClass("text-red");
				let mor = this.newMoreInfoRow();
				mor.addClass("text-red");
				mor.text("Requires Armour Proficiency at " + Helper.toSkill(this.item.getMinimumSkillNeededForArmour()));
				this.mc.append(mor);
			} else {
				let mor = this.newMoreInfoRow();
				mor.html("&nbsp;");
				this.mc.append(mor);
			}

		} else {
			let mor = this.newMoreInfoRow();
			mor.html("&nbsp;");
			this.mc.append(mor);
		}

	}


	buildDamageMinMax() {
		let row = this.newInfoRow();
		row.addClass("js-attack-min");
		jQuery(".js-sx", row).text("Damage min");
		jQuery(".js-dx", row).text(Helper.toNumber(this.item.attack_min));
		this.mc.append(row);

		row = this.newInfoRow();
		row.addClass("js-attack-max");
		jQuery(".js-sx", row).text("Damage max");
		jQuery(".js-dx", row).text(Helper.toNumber(this.item.attack_max));
		this.mc.append(row);
	}

	buildSpeed() {
		let row = this.newInfoRow();
		row.addClass("js-speed");
		jQuery(".js-sx", row).text("Speed");
		jQuery(".js-dx", row).text(this.item.speed);
		this.mc.append(row);
	}

	buildSeparator() {
		let mor = this.newMoreInfoRow();
		mor.html("&nbsp;");
		this.mc.append(mor);
	}

	buildBonusSkill() {
		let bonus = this.item.bonus_skill;
		if (bonus > 0) {
			this.buildSeparator()
			let row = this.newInfoRow();
			row.addClass("js-bonus-skill");
			jQuery(".js-sx", row).text(Skills.getSkillName(this.item.player_skill));
			jQuery(".js-dx", row).text(Helper.toSkill(this.item.bonus_skill, true));
			/*if (this.item.bonus_skill < 0) {
				jQuery(".js-dx", row).addClass("text-red");
			} else {
				jQuery(".js-dx", row).addClass("text-green");
			}*/
			this.mc.append(row);
		}

	}

	buildDefense() {
		let row = this.newInfoRow();
		row.addClass("js-defense");
		jQuery(".js-sx", row).text("Armour");
		jQuery(".js-dx", row).text(this.item.defense);
		this.mc.append(row);
	}
	buildBonus() {
		let row;
		//if (this.item.bonus_damage > 0) {
		row = this.newInfoRow();
		row.addClass("js-bonus-damage");
		jQuery(".js-sx", row).text("Damage");
		jQuery(".js-dx", row).text(Helper.toSkill(this.item.bonus_damage, true));
		this.mc.append(row);
		/*if (this.item.bonus_damage < 0) {
			jQuery(".js-dx", row).addClass("text-red");
		} else {
			jQuery(".js-dx", row).addClass("text-green");
		}*/
		//}
		//if (this.item.bonus_defense > 0) {
		row = this.newInfoRow();
		row.addClass("js-bonus-defense");
		jQuery(".js-sx", row).text("Armour");
		jQuery(".js-dx", row).text(Helper.toSkill(this.item.bonus_defense, true));
		this.mc.append(row);
		/*if (this.item.bonus_defense < 0) {
			jQuery(".js-dx", row).addClass("text-red");
		} else {
			jQuery(".js-dx", row).addClass("text-green");
		}*/

		//}
		//if (this.item.bonus_speed > 0) {
		row = this.newInfoRow();
		jQuery(".js-sx", row).text("Speed");
		row.addClass("js-bonus-speed");
		jQuery(".js-dx", row).text(Helper.toSkill(this.item.bonus_speed, true));
		this.mc.append(row);
		/*if (this.item.bonus_speed < 0) {
			jQuery(".js-dx", row).addClass("text-red");
		} else {
			jQuery(".js-dx", row).addClass("text-green");
		}*/

		//}
	}


	buildCtas() {
		let h = this.mc.outerHeight()
		let tiles = Math.ceil(h / Game.TILE_HEIGHT) + 2;
		jQuery(".js-buttons", this.mc).css("top", tiles * Game.TILE_HEIGHT - jQuery(".js-buttons", this.mc).height() - 20);
		if (!this.item.consumable) {
			jQuery(".js-use", this.mc).hide();
			jQuery(".js-sep", this.mc).hide();
		} else {

			jQuery(".js-btn-use", this.mc).hide();
			jQuery(".js-btn-cook", this.mc).hide();
			jQuery(".js-btn-drink", this.mc).hide();
			jQuery(".js-btn-eat", this.mc).hide();
			if (Screen.that.heroIsNearLightFireplace() && (this.item.cookable)) {
				jQuery(".js-btn-cook", this.mc).show();
				jQuery(".js-use", this.mc).on("click", this.onUse.bind(this, true));
			} else {
				if (this.item.drinkable) {
					jQuery(".js-btn-drink", this.mc).show();
					jQuery(".js-use", this.mc).on("click", this.onUse.bind(this, false));
				} else if (this.item.edible) {
					jQuery(".js-btn-eat", this.mc).show();
					jQuery(".js-use", this.mc).on("click", this.onUse.bind(this, false));
				} else {
					jQuery(".js-btn-use", this.mc).show();
					jQuery(".js-use", this.mc).on("click", this.onUse.bind(this, false));
				}
			}


		}
		jQuery(".js-destroy", this.mc).on("click", this.onDestroy.bind(this))
	}

	buildFood() {
		if (this.item.edible) {
			if (this.item.food > 0) {
				let row = this.newInfoRow();
				jQuery(".js-sx", row).text("Food");
				jQuery(".js-dx", row).text(this.item.food);
				this.mc.append(row);
			}
		}
		if (this.item.cookable) {
			let row = this.newInfoRow();
			jQuery(".js-sx", row).text("Cookable");
			jQuery(".js-dx", row).text("yes");
			this.mc.append(row);
			row = this.newInfoRow();
			jQuery(".js-sx", row).text("Cooking skill");
			jQuery(".js-dx", row).text(Helper.toSkill(this.item.cookskill));
			this.mc.append(row);

		}

	}
	buildWater() {
		if (this.item.drinkable) {
			if (this.item.water > 0) {
				let row = this.newInfoRow();
				jQuery(".js-sx", row).text("Water");
				jQuery(".js-dx", row).text(this.item.water);
				this.mc.append(row);
			}
		}
	}
	buildHeal() {

		if (this.item.heal > 0) {
			let row = this.newInfoRow();
			jQuery(".js-sx", row).text("Heal");
			jQuery(".js-dx", row).text(this.item.heal);
			this.mc.append(row);
		}

	}

	onUse(lCook) {
		Bout.incStatistic(Bout.STAT_SCORE, Game.SCORE_COOK);
		this.dispatch({ type: ItemInfo.EVENT_USE, data: this, cook: lCook });

	}
	onDestroy() {
		this.dispatch({ type: ItemInfo.EVENT_DESTROY, data: this });
	}

	getHeight() {
		return jQuery(".js-buttons", this.mc).position().top + jQuery(".js-buttons", this.mc).height();
	}

}

ItemInfo.ENUM = 0;

ItemInfo.EVENT_USE = "EventUse";
ItemInfo.EVENT_DESTROY = "EventDestroy";
